import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import { getEventDetail } from "../requests/event-detail.requests";

export const useGetEventDetail = (
  eventUuid: string | null | undefined,
  options?: {
    /**
     * Poll at this interval while the detail has no images yet — live events
     * start frameless and gain frames seconds later. Polling stops once images
     * arrive (every response re-signs the URLs, which would churn rendered
     * `<img>` tags).
     */
    pollMsWhileFrameless?: number | false;
  },
) => {
  const pollMs = options?.pollMsWhileFrameless;
  return useQuery({
    queryKey: [QUERY_KEYS.EVENT_DETAIL, eventUuid],
    queryFn: () => getEventDetail(eventUuid as string),
    enabled: !!eventUuid,
    staleTime: 5 * 60_000,
    refetchInterval: pollMs
      ? (query) => ((query.state.data?.images?.length ?? 0) > 0 ? false : pollMs)
      : false,
  });
};
